
const FloatingBanner = () => {
  return (
    <div className="fixed-top bg-primary text-white py-2 px-3">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col text-center text-md-start">
            <h1>Referentieniveau</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingBanner;

